import Fitting from '@/models/Fitting';
import LensOrderUrlManager from '../LensOrderUrlManager';
import BasketLine from '@/models/BasketLine';
import FittingSession from '@/models/FittingSession';

export default class SetFittingValuesByBasketLine
{
    /**
     * Vue Object
     */
    v = null;

    /**
     * "right" or "left"
     * @string
     */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        /** @type {LensOrderUrlManager} */
        const lensOrderUrlManager = this.v.lensOrderUrlManager;
        if(!lensOrderUrlManager.hasBasketLineId(this.side))
        {
            return true;
        }

        const basketLineId = lensOrderUrlManager.getBasketLineId(this.side);
        /** @type {BasketLine} */
        const basketLine = this.v.$store.getters['basket/getById'](basketLineId);
        /** @type {Fitting} */
        const fitting = this.v.$store.getters['lensOrder/getFitting'](this.side);

        // Set basket line ID
        fitting.basket_line_id = basketLine.id;

        // Set fitting session ID
        if(basketLine.fitting_session_id)
        {
            fitting.session_id = basketLine.fitting_session_id;
        }

        return true;
    }
}
